<div class="dialog-wrapper">
  <!-- ── Header ──────────────────────────────────── -->
  <div class="dialog-header">
    <!-- <div class="header-icon-wrap">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 11H13V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z" />
      </svg>
    </div> -->
    <div class="header-text">
      <p class="dialog-title">{{ productData.ProductID ? "Update Product" : "Add New Product" }}</p>
      <p class="dialog-subtitle">Fill in the details below to {{ productData.ProductID ? "update the" : "create a new" }} product</p>
    </div>
  </div>

  <!-- ── Body ────────────────────────────────────── -->
  <mat-dialog-content class="mat-typography" style="max-height: 62vh; overflow-y: auto; padding: 0 20px">
    <!-- SECTION: Basic Information -->
    <div class="form-section">
      <div class="section-label">Basic Information</div>

      <div class="row g-3">
        <!-- Product Name -->
        <div class="col-md-6 col-12">
          <div class="field-group">
            <label for="productName" class="field-label"> Product Name&nbsp;<span class="required-dot"></span> </label>
            <input id="productName" class="modern-input" maxlength="45" [(ngModel)]="productData.ProductName" name="productName" placeholder="Enter product name" />
          </div>
        </div>

        <!-- Product Company -->
        <div class="col-md-3 col-12">
          <app-multi-select-dropdown
            label="Product Company"
            placeholder="Select Company"
            [items]="companyList"
            valueProperty="CompanyID"
            displayProperty="CompanyName"
            [(model)]="productData.CompanyID">
          </app-multi-select-dropdown>
        </div>

        <!-- Product Size -->
        <div class="col-md-3 col-12">
          <app-multi-select-dropdown
            label="Product Size"
            placeholder="Select Size"
            [items]="productSizeList"
            [isMultiSelect]="true"
            valueProperty="SizeID"
            displayProperty="Size"
            [(model)]="selectedSizeIDs">
          </app-multi-select-dropdown>
        </div>

        <!-- Size Quantities — compact inline chips -->
        <div class="col-12" *ngIf="productData.Size && productData.Size.length > 0">
          <div class="qty-inline-row">
            <span class="qty-inline-label">Qty per size:</span>
            <div class="qty-chip" *ngFor="let item of productData.Size; let i = index">
              <span class="qty-chip-name">{{ getSizeName(item.SizeID) }}</span>
              <input type="number" class="qty-chip-input" [(ngModel)]="item.Quantity" [name]="'qty_' + i" placeholder="0" min="0" />
            </div>
          </div>
        </div>

        <!-- Amount -->
        <div class="col-md-3 col-12">
          <div class="field-group">
            <label for="Amount" class="field-label"> Amount (₹)&nbsp;<span class="required-dot"></span> </label>
            <input id="Amount" class="modern-input" allowDecimal [(ngModel)]="productData.Amount" name="Amount" placeholder="0.00" />
          </div>
        </div>

        <!-- Description -->
        <div class="col-12">
          <div class="field-group">
            <label for="Description" class="field-label">Description</label>
            <textarea id="Description" class="modern-input" rows="2" [(ngModel)]="productData.Description" name="Description" placeholder="Briefly describe this product..."></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION: Tax & Discounts -->
    <!-- <div class="form-section">
      <div class="section-label">Tax &amp; Discounts</div>

      <div class="row g-2">
        <div class="col-md-3 col-6">
          <div class="stat-card">
            <div class="stat-card-label">SGST (%)</div>
            <input id="SGST" class="stat-card-input" allowDecimal [(ngModel)]="productData.SGST" name="SGST" placeholder="0.00" />
          </div>
        </div>

    
        <div class="col-md-3 col-6">
          <div class="stat-card">
            <div class="stat-card-label">CGST (%)</div>
            <input id="CGST" class="stat-card-input" allowDecimal [(ngModel)]="productData.CGST" name="CGST" placeholder="0.00" />
          </div>
        </div>

        <div class="col-md-3 col-6">
          <div class="stat-card">
            <div class="stat-card-label">Student Discount</div>
            <input id="StudentDiscount" class="stat-card-input" allowDecimal [(ngModel)]="productData.StudentDiscount" name="StudentDiscount" placeholder="0.00" />
          </div>
        </div>

        <div class="col-md-3 col-6">
          <div class="stat-card">
            <div class="stat-card-label">Min Discount</div>
            <input id="MinDiscount" class="stat-card-input" allowDecimal [(ngModel)]="productData.MinDiscount" name="MinDiscount" placeholder="0.00" />
          </div>
        </div>
      </div>
    </div> -->

    <!-- SECTION: Additional Notes -->
    <div class="form-section">
      <div class="section-label">Additional Notes</div>

      <div class="field-group">
        <label for="Remarks" class="field-label">Remarks</label>
        <textarea id="Remarks" class="modern-input" rows="2" [(ngModel)]="productData.Remarks" name="Remarks" placeholder="Any additional remarks or notes..."></textarea>
      </div>
    </div>

    <!-- Active Status Toggle -->
    <div class="active-toggle-row">
      <label for="IsActive" class="active-toggle-label">Is Active</label>
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" id="IsActive" [(ngModel)]="productData.IsActive" name="IsActive" />
      </div>
    </div>

    <!-- SECTION: Product Image -->
    <div class="form-section">
      <div class="section-label">Product Image</div>
      <app-document-upload
        label="Upload Product Image"
        category="Image"
        [documents]="uploadedDocuments['Image'] || []"
        (documentsChange)="updateDocuments($event)"
        (documentRemove)="removeFile($event)">
      </app-document-upload>
    </div>
  </mat-dialog-content>

  <!-- ── Footer Actions ──────────────────────────── -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="onClose()">Cancel</button>
    <button class="btn-submit" (click)="onSubmit()">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path *ngIf="!productData.ProductID" d="M19 11H13V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z" />
        <path *ngIf="productData.ProductID" d="M21 7 9 19l-5.5-5.5 1.41-1.41L9 16.17 19.59 5.59 21 7z" />
      </svg>
      {{ productData.ProductID ? "Update Product" : "Add Product" }}
    </button>
  </div>
</div>
